// services/statistics.js
import axiosInstance from './axiosInstance';

const STATISTICS_API_URL = '/statistics';

const statisticsService = {
  async getCustomerStats(idempresa, codigo, startDate, endDate, nif = null) {
    try {
      const nifParam = nif ? `&nif=${nif}` : '';
      const response = await axiosInstance.get(`${STATISTICS_API_URL}/customer/get.php?idempresa=${idempresa}&customer=${codigo}&startdate=${startDate}&enddate=${endDate}${nifParam}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export default statisticsService;
